// eslint-disable-next-line
import moment from 'moment'

export default {

  data () {
    return {
      audio: null
    }
  },

  destroyed () {
    this.audio && this.audio.pause()
  },

  methods: {
    playAudioFile (path, mtc = null) {
      this.audio && this.audio.pause()
      this.audio = new window.Audio(path)

      if (mtc) {
        this.audio.currentTime = mtc.mtc_begin / 1000
        this.audio.addEventListener('timeupdate', function () {
          if (this.currentTime >= mtc.mtc_end / 1000) {
            this.pause()
          }
        })
      }

      this.audio.play()
    },

    stopAudioFile () {
      if (this.audio) {
        this.audio.pause()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/live-player/components/mixins/audioPlayerMixin.js